import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home } from 'lucide-react';

const BackToHome = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  // Pages where we don't show the button
  const hideOnPaths = ['/', '/login/health', '/register/health'];
  const isHidden = hideOnPaths.includes(location.pathname);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200);
    };
    // Show immediately on non-landing pages
    if (!isHidden) {
      setVisible(true);
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHidden]);

  if (isHidden || !visible) return null;

  return (
    <button
      onClick={() => navigate('/')}
      className="fixed bottom-20 left-4 z-50 flex items-center gap-2 px-3 py-2.5 bg-white/90 backdrop-blur-md border border-gray-200 rounded-full shadow-lg hover:shadow-xl hover:bg-white transition-all duration-300 text-gray-700 hover:text-orange-600 group"
      data-testid="back-to-home-btn"
      aria-label="Back to Home"
    >
      <Home className="w-4 h-4 group-hover:scale-110 transition-transform" />
      <span className="text-xs font-semibold hidden sm:inline">Home</span>
    </button>
  );
};

export default BackToHome;
